import { svgToIcon } from '../utils/svg';
import arrowIcon from '../assets/icons/shapeArrow.svg';
import PolygonBase from './PolygonBase';
import { type IPoint } from 'fabric/fabric-impl';

const HEAD_WIDTH = 0.5;
const HEAD_MAX_WIDTH = 0.8;
const TAIL_THICKNESS = 0.5;

class ShapeArrow extends PolygonBase {
  static polygonPoints(scaleX: number = 1, scaleY: number = 1): IPoint[] {
    const w = this.width;
    const h = this.height;
    const sw = w * scaleX;
    const sh = h * scaleY;
    const ratio = sw / sh;
    const threshold = HEAD_WIDTH / HEAD_MAX_WIDTH;
    const tail = TAIL_THICKNESS / 2.0;
    let headW = HEAD_WIDTH / ratio;
    const headH = 0.5;
    if (ratio < threshold) {
      // Narrow shapes, scale the head down
      headW = HEAD_MAX_WIDTH;
    }
    const points = [
      // Head
      // Top left edge of arrow
      { x: 0.5 - headW, y: -tail }, // bl
      { x: 0.5 - headW, y: -headH }, // tl

      // Tip
      { x: 0.5, y: 0.0 },

      // Bottom left edge of arrow
      { x: 0.5 - headW, y: headH }, // tl
      { x: 0.5 - headW, y: tail }, // bl

      // Tail
      { x: -0.5, y: tail }, // bl
      { x: -0.5, y: -tail }, // tl
      { x: 0.5 - headW, y: -tail }, // tr
    ];

    return points;
  }

  static dynamicPathString(scaleX: number, scaleY: number) {
    const points = this.polygonPoints(scaleX, scaleY);

    const start = points[0];
    let path = `M ${start.x} ${start.y}\n`;
    for (const { x, y } of points.slice(1)) {
      path += `L ${x} ${y}\n`;
    }
    path += `Z\n`;
    return path;
  }

  static renderIcon() {
    return svgToIcon(arrowIcon);
  }
}

export default ShapeArrow;
